import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const settingsGroupSectionStyle1 = css`
  margin-bottom: ${theme.spacing(3)};
  width: 100%;
`;

const settingsGroupHeaderStyle3 = css`
  display: flex;
  align-items: center;
`;

const headerCondensed = css`
  margin-bottom: 0;
`;

const headerStandard = css`
  margin-bottom: ${theme.spacing(1)};
`;

const settingsGroupHeadingStyle4 = css`
  margin: 0;
`;

const settingsGroupInfoStyle5 = css`
  display: flex;
  margin-left: ${theme.spacing(1)};
`;

const settingsGroupTextButtonStyle6 = css`
  margin-left: auto;
`;

export const SettingsGroupStyles = {
  settingsGroupSectionStyle1,
  settingsGroupHeaderStyle3,
  headerCondensed,
  headerStandard,
  settingsGroupHeadingStyle4,
  settingsGroupInfoStyle5,
  settingsGroupTextButtonStyle6,
};
